// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
let module = angular.module('app.directives', []);

// The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.
require('./backhaul_graph');
require('./boxcaster_cpu_graph');
require('./boxcaster_graph');
require('./boxcaster_network_graph');
require('./boxcaster_pro_temperature_graph');
require('./boxcaster_pro_video_inputs_graph');
require('./boxcaster_serial_input_graph');
require('./boxcaster_single_value_graph');
require('./boxcaster_video_inputs_graph');
require('./broadcast_graph');
require('./broadcaster_graph');
require('./broadcasts_today_graph');
require('./enter');
require('./low-latency-player');
require('./firmware_version');
require('./match');
require('./pagination');
require('./player');
require('./rickshaw');
require('./slider');

// View-specific directives
require('../views/dashboard/dashboard_directives');

export default module;


// WEBPACK FOOTER //
// ./directives/index.js